export interface CommunicationProviderProfileBase {
  id: string;
  name: string;
}

export enum CommunicationProviderType {
  UNDEFINED = 'UNDEFINED',
  SLACK_APP = 'SLACK_APP',
  DISCORD_APP = 'DISCORD_APP',
  TEAMS = 'TEAMS',
  MAIL = 'MAIL',
  FCM = 'FCM',
}

export interface SlackAppProviderProfileConfiguration {
  teamName: string;
}

export interface DiscordAppProviderProfileConfiguration {
  guildName: string;
}

export interface TeamsProviderProfileConfiguration {
  teamName: string;
}

export type CommunicationProviderProfile = CommunicationProviderProfileBase &
  (
    | {
        type: CommunicationProviderType.SLACK_APP;
        configuration: SlackAppProviderProfileConfiguration;
      }
    | {
        type: CommunicationProviderType.DISCORD_APP;
        configuration: DiscordAppProviderProfileConfiguration;
      }
    | {
        type: CommunicationProviderType.TEAMS;
        configuration: TeamsProviderProfileConfiguration;
      }
  );

export interface ProviderProfileConfigFieldMapping<T> {
  fieldName: string;
  configName: keyof T;
}
